// Priority/capacity engine (setter spec §06.1–§06.9), live transfer (§05.22) and inbound out of hours (C9), Wave 4B.
// Schemas in api-priorities.ts. Part of the AI calls module.
import * as P from './api-priorities.js';
import { OkSchema } from './api.js';
import { IdParam, route, W, Ws } from './route-def.js';

export const priorityRoutes = {
  getPriorityQueue: route({
    method: 'GET', path: '/workspaces/:workspaceId/priorities/queue', summary: 'Cola de trabajo de llamadas: capacidad, prioridad, compromisos y métricas', tag: 'priorities',
    minRole: 'manager', params: Ws, query: P.PriorityQueueQuerySchema, response: P.PriorityQueueViewSchema,
  }),
  putPrioritySettings: route({
    method: 'PUT', path: '/workspaces/:workspaceId/priorities/settings', summary: 'Capacidad de llamadas simultáneas y SLA de leads nuevos (auditado)', tag: 'priorities',
    minRole: 'admin', params: Ws, body: P.PutWorkspacePrioritySettingsSchema, response: P.PriorityQueueViewSchema,
  }),
  cancelCommitment: route({
    method: 'POST', path: '/workspaces/:workspaceId/priorities/commitments/:commitmentId/cancel', summary: 'Cancelar una hora pactada que ya no aplica (auditado)', tag: 'priorities',
    minRole: 'manager', params: W({ commitmentId: IdParam }), body: P.CancelCommitmentSchema, response: OkSchema,
  }),
  getProjectPriorities: route({
    method: 'GET', path: '/workspaces/:workspaceId/projects/:projectId/priorities', summary: 'Entrantes fuera de horario del proyecto (C9)', tag: 'projects',
    minRole: 'advisor', params: W({ projectId: IdParam }), response: P.ProjectPrioritySettingsSchema,
  }),
  putProjectPriorities: route({
    method: 'PUT', path: '/workspaces/:workspaceId/projects/:projectId/priorities', summary: 'Guardar si la IA contesta entrantes fuera de horario (auditado)', tag: 'projects',
    minRole: 'admin', params: W({ projectId: IdParam }), body: P.PutProjectPrioritySettingsSchema, response: P.ProjectPrioritySettingsSchema,
  }),
} as const;
